import header from "./grundriss-sichtung.png";
import section1 from "./expose-und-grundriss.webp";
import section2 from "./grundriss-tablet-notizen.jpg";

export { header, section1, section2 };
